import { Box, LinearProgress } from "@material-ui/core";
import { createRef, FC, useEffect } from "react";
import { fromEvent, Subscription } from "rxjs";
import { filter, pluck } from "rxjs/operators";

import { GenericFunction } from "../types/generic.types";

const OnScroll: FC<OnScrollProps> = ({ children, onScrollTop, loading, deps = [] }) => {
  const scrollRef = createRef<any>();

  useEffect(() => {
    let scrollSubscription: Subscription;
    let fetchMoreDataSubscription: Subscription;

    if (scrollRef) {
      scrollSubscription = fromEvent(scrollRef.current, "scroll")
        .pipe(
          pluck("target"),
          filter((target) => (target as Element).scrollTop === 0)
        )
        .subscribe({
          next() {
            if (onScrollTop) fetchMoreDataSubscription = onScrollTop();
          },
        });
    }

    return () => {
      if (scrollSubscription) scrollSubscription.unsubscribe();
      if (fetchMoreDataSubscription) fetchMoreDataSubscription.unsubscribe();
    };
  }, [scrollRef, onScrollTop]);

  useEffect(() => {
    if (scrollRef) {
      scrollRef.current.scrollTo({ top: scrollRef.current.scrollHeight, behavior: "smooth" });
    }
  }, deps);

  return (
    <Box height="100%" position="relative">
      {loading ? (
        <LinearProgress
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: 4,
            width: "100%",
            zIndex: 5,
          }}
        />
      ) : null}
      <Box overflow="auto" height="100%" {...{ ref: scrollRef }}>
        {children}
      </Box>
    </Box>
  );
};

interface OnScrollProps {
  onScrollTop: GenericFunction;
  loading: boolean;
  deps?: any[];
}

export default OnScroll;
